export default "__VITE_ASSET__DO7Gj$dY__"